import { ButtonLink } from '@design';
import { appPaths } from '@terminal/routes/app-paths';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import styles from './Footer.module.scss';

export interface FooterProps {
  hasScroll: boolean;
  onClose: () => void;
}

export const Footer = ({ hasScroll, onClose }: FooterProps) => {
  const { t } = useTranslation('alerts', { useSuspense: false });
  const navigate = useNavigate();
  const { trackAlertsPageOpen } = usePosthogEvents();

  const handleNavigateToAlerts = () => {
    trackAlertsPageOpen(POSTHOG_TRACKING_SOURCES.ALERTS_DROPDOWN);
    onClose();
    navigate(appPaths.alerts);
  };

  return (
    <div
      className={clsx(styles.footerRoot, {
        [styles.hasScroll]: hasScroll,
      })}
    >
      <ButtonLink
        className={styles.styledButtonLink}
        label={t('dropdown.viewPastNotifications')}
        onClick={handleNavigateToAlerts}
      />
    </div>
  );
};
